import { useState } from "react";
import { Link } from "react-router-dom";
import { Trash2, Minus, Plus, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { Layout, PageHeader } from "../components/Layout";
import { useCart } from "../context/CartContext";
import api from "../lib/api";

export default function Cart() {
  const { items, remove, setQty, total } = useCart();
  const [busy, setBusy] = useState(false);

  const checkout = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        kind: "cart", origin_url: window.location.origin,
        items: items.map((i) => ({ product_id: i.product_id, quantity: i.quantity })),
      });
      window.location.href = data.checkout_url;
    } catch { toast.error("Could not start checkout"); setBusy(false); }
  };

  return (
    <Layout>
      <PageHeader label="Your Cart" title="Checkout" />
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-10">
        {items.length === 0 ? (
          <div className="text-center py-24 border border-eon-border">
            <ShoppingBag size={40} className="text-eon-muted mx-auto" />
            <p className="mt-4 text-eon-muted">Your cart is empty.</p>
            <Link to="/shop" className="inline-block mt-6 bg-eon-gold text-white text-sm font-bold uppercase tracking-wider px-8 py-3 hover:bg-eon-goldhover transition-colors">Shop Now</Link>
          </div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-3">
              {items.map((i) => (
                <div key={`${i.product_id}-${i.size || ""}`} data-testid={`cart-item-${i.product_id}`} className="eon-card p-4 flex items-center gap-4">
                  <img src={i.image} alt="" className="w-20 h-20 object-cover" />
                  <div className="flex-1"><div className="font-display font-bold">{i.name}</div>{i.size && <div className="eon-label mt-0.5">Size: {i.size}</div>}<div className="text-sm text-eon-gold font-mono">${i.price.toFixed(2)}</div></div>
                  <div className="flex items-center border border-eon-border">
                    <button onClick={() => setQty(i.product_id, i.quantity - 1, i.size)} className="p-2 hover:text-eon-gold"><Minus size={14} /></button>
                    <span className="w-8 text-center text-sm">{i.quantity}</span>
                    <button onClick={() => setQty(i.product_id, i.quantity + 1, i.size)} className="p-2 hover:text-eon-gold"><Plus size={14} /></button>
                  </div>
                  <button onClick={() => remove(i.product_id, i.size)} data-testid={`cart-remove-${i.product_id}`} className="text-eon-muted hover:text-red-400 p-2"><Trash2 size={18} /></button>
                </div>
              ))}
            </div>
            <div className="eon-card p-6 h-fit sticky top-24">
              <div className="eon-label mb-4">Order Summary</div>
              <div className="flex justify-between text-sm mb-2"><span className="text-eon-muted">Subtotal</span><span className="font-mono">${total.toFixed(2)}</span></div>
              <div className="flex justify-between text-sm mb-4"><span className="text-eon-muted">Tax & shipping</span><span className="font-mono text-eon-muted">At checkout</span></div>
              <div className="flex justify-between border-t border-eon-border pt-4 mb-6"><span className="font-display font-bold">Total</span><span className="font-mono text-eon-gold text-lg">${total.toFixed(2)}</span></div>
              <button onClick={checkout} disabled={busy} data-testid="cart-checkout-btn" className="w-full bg-eon-gold text-white font-bold uppercase tracking-wider py-3.5 hover:bg-eon-goldhover transition-colors disabled:opacity-50">{busy ? "Redirecting..." : "Checkout with Stripe"}</button>
              <p className="text-xs text-eon-muted mt-4 text-center">Test card: 4242 4242 4242 4242</p>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
